import DashboardPage from "./DashboardPage";
import HistoryDashboard from "../../components/Dashboard/HistoryDashboard";

export default function DashboardsHistory() {
  return (
    <DashboardPage
      title="Evolução histórica"
      subtitle="Nota média do portfólio ano a ano"
      info="Cada barra é um exercício (ano). A comparação fica rica conforme mais anos acumulam."
    >
      <HistoryDashboard />
    </DashboardPage>
  );
}
